import { withLocaleStaticPaths, withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import HistoryView from 'src/views/History';
export const getStaticPaths = withLocaleStaticPaths();
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true
  }
}), {
  xDefaultRouteFn: () => ({
    pathname: '/history'
  })
});
export default HistoryView;